import { mediaManagerPreviewActionsParams } from '@wix/bi-logger-media-manager-g6/v2/types';
import { MediaManagerSDKAnyItem } from '../../../media-manager-sdk';

export enum ClickOrigin {
  MoreInfo = 'more_info',
  Actions = 'actions',
  LeftArrow = 'left_arrow',
  RightArrow = 'right_arrow',
  PreviewBottomNavigation = 'preview_bottom_navigation',
  Breadcrumbs = 'breadcrumbs',
  TopRight = 'top_right',
  MoveTo = 'move_to',
  EmptyFolderOrFilter = 'empty_folder_or_filter',
  Keyboard = 'keyboard',
  Panel = 'panel',
  CloseIcon = 'close_icon',
  VideoPlay = 'video_play',
  FileClick = 'file_click',
}

export enum PreviewTarget {
  Opened = 'opened',
  Closed = 'closed',
}

export interface IWithTrackPreviewActionsInner {
  trackPreviewActionsExpandButtonClicked: (clickOrigin: ClickOrigin) => void;
  trackPreviewActionsPreviewBottomNavigationClicked: (item: MediaManagerSDKAnyItem) => void;
  trackPreviewActions: (
    params: mediaManagerPreviewActionsParams,
    item: MediaManagerSDKAnyItem | MediaManagerSDKAnyItem[],
  ) => void;
}

export interface IWithTrackPreviewActionsOuter {}
